import config from "config/config";

export const isPolicyPayoutAnnuity = (policy) => {
  let payoutPolicyProductTypes = config.PAYOUT_POLICY_PRODUCT_TYPES.split(",");
  let findPayoutAnnuiniyPolicy = payoutPolicyProductTypes.find(
    (productType) => productType === policy?.product?.type?.toLowerCase()
  );
  if (findPayoutAnnuiniyPolicy) return true;
  return false;
};
